module.exports = __webpack_public_path__ + "img/logoicon.91fa096b.png";